import { Page } from "@nimbus-ds/patterns";
import CustomCard from "./CustomCard";
// import LanguageSelector from "./LanguageSelector";

const MainHome = ({ storeInfo }: { storeInfo: any }) => {
  return (
    <Page maxWidth="1920px">
      <Page.Body>
        <div className="mainhome-flag-container">
          {/* <LanguageSelector /> */}
        </div>
        <div className="mainhome-container">
          {/* <CustomCard
            title="card.manageCredentials.title" // Translation key for title
            text="card.manageCredentials.text" // Translation key for text
            buttonText="button.go" // Translation key for button text
            route="/manage-credentials"
          /> */}
          <CustomCard
            title="card.manageProducts.title"
            text="card.manageProducts.text"
            buttonText="card.manageProducts.buttonText"
            route="/manage-products"
          />
        </div>
      </Page.Body>
    </Page>
  );
};

export default MainHome;
